import type { Element } from 'react'
import React from 'react'
import { Menu } from './Menu'
import { media, ResponsiveContainer } from 'app/assets/styles'
import type { EventMetadata } from 'shared/store/metadata'
import styled from 'styled-components'
import type { MenuListItem } from 'app/common/layout/menu'

type Props = {
    children?: Element<any>,
    menuItems: Array<MenuListItem>,
    sendMeta?: EventMetadata => void,
    route: string,
    menuBackgroundImage?: boolean,
    menuTitle?: string,
    hideMobileMenu?: boolean,
    hideDesktopMenu?: boolean,
    background?: string,
    className?: string
}

const MenuLayout = (props: Props) => {
    const {
        menuItems,
        sendMeta,
        route,
        menuTitle,
        menuBackgroundImage,
        hideMobileMenu = true,
        hideDesktopMenu = false,
        background = 'white',
        children,
        className
    } = props
    return (
        <Container background={background}>
            <StyledResponsiveContainer className={className}>
                <Menu
                    hideMobileMenu={hideMobileMenu}
                    hideDesktopMenu={hideDesktopMenu}
                    categories={menuItems}
                    sendMeta={sendMeta}
                    propRoute={route}
                    menuTitle={menuTitle}
                    menuBackgroundImage={menuBackgroundImage}
                />
                {children}
            </StyledResponsiveContainer>
        </Container>
    )
}

const Container = styled.div`
    background-color: ${props => props.background};
`

const StyledResponsiveContainer = styled(ResponsiveContainer)`
    margin-top: 80px;
    &.dashboard {
        margin-top: -20px;
    }
    display: flex;
    flex-direction: column-reverse;
    ${media.medium`
        margin-top: 90px;
        flex-direction: row;
        justify-content: flex-start;
    `};
    ${media.large`
        width: 100%;
    `};
`

export { MenuLayout }
